{
  "IlhClientServiceInquiryComponent": {
    "TABLE": {
      "SEARCH_BY": {
        "POLICY_NUMBER": true,
        "CLIENT": {
          "ENABLED": true,
          "CLIENT_NAME": true,
          "CLIENT_NUMBER": true
        },
        "DOB": true,
        "SSN": true,
        "PHONE": true,
        "BANK_ACC": true,
        "RESIDENCE_STATE": true
      },

      "POLICY_SEARCH": {
        "INSURED": true,
        "POLICY_NUMBER": true,
        "SSN": true,
        "STATE": true,
        "ISSUED_DATE": true,
        "PAID_TO": true,
        "DOB": true,
        "GENDER": true,
        "LAST_PAID": true,
        "CARD_ACTIONS": {
          "VIEW": true,
          "ADD_NOTE": true
        }
      }
    },
    "DETAILS": {
      "HeaderCardComponent": {
        "STATUS": true,
        "SEARCH": true,
        "AVATAR": true,
        "DOB_GENDER": {
          "ENABLED": true,
          "DOB": true,
          "GENDER": true
        },
        "SSN": true,
        "MAIDEN_NAME": true,
        "ADDRESS": true,
        "CONTACT_INFO": {
          "ENABLED": true,
          "EMAIL": true,
          "PHONE_WORK": true,
          "PHONE_HOME": true,
          "PHONE_CELL": true
        },
        "POLICY_ACTIONS": {
          "ADD_NOTE": true,
          "SCAN": true,
          "ATTACH": true
        }
      },
      "IlhClientServiceInquiryDetailsPolicyComponent": {
        "ENABLED": true,
        "IlhClientServiceInquiryDetailsPolicyInfoComponent": {
          "ENABLED": true,
          "VITAL_DATES": {
            "ENABLED": true,
            "APPLICATION_DATE": true,
            "ISSUE_DATE": true,
            "LAST_PAID": true,
            "PAID_TO": true,
            "RENEWAL_DATE": true,
            "NEXT_CHANGE_DATE": true,
            "NEXT_CHANGE_CODE": true,
            "INFORCE_DATE": false,
            "REINSTATEMENT_DATE": false
          },
          "POLICY": {
            "ENABLED": true,
            "STATE_OF_APP": true,
            "JET_ISSUE": true,
            "POLICY_FEE": true,
            "RECEIVED": true,
            "RESTRICT_CODE": true,
            "REISSUE": true,
            "PARISH": true,
            "AREA": true,
            "NON_FORF": true,
            "MEC": true,
            "ANNUITY_TYPE": true,
            "LEGACY": false
          },
          "BILLING": {
            "ENABLED": true,
            "LAST_BILLED": true,
            "SPECIAL_BILLING": true,
            "BILL_DAY": true,
            "BILL_STATUS": true,
            "BILL_MODE": true,
            "BILL_FORM": true,
            "BANK_NUM": true,
            "TRANSIT_NUM": true,
            "CHECK_SAV_INDICATOR": true,
            "DRAFT_DATE": false,
            "FLEX_BILLING_DATE": false,
            "FLEX": false,
            "POLICY_REASON": false
          },
          "MODAL_PREMIUM": {
            "ENABLED": true,
            "MONTHLY": true,
            "QUARTERLY": true,
            "SEMI": true,
            "ANNUAL": true
          },
          "SUSPENSE": {
            "ENABLED": true,
            "PREMIUM_SUSPENSE": true,
            "PREMIUM_DATE": true,
            "PREMIUM_AMT": true,
            "RETURN_CHK": true,
            "RETURN_CHK_DATE": true,
            "RETURN_CHK_AMT": true,
            "REJ_CASH": true
          },
          "PREMIUM_DEPOSIT": {
            "ENABLED": true,
            "BILLED": true,
            "TYPE": true,
            "LAST_ENTRY_DATE": true,
            "RATE": true,
            "BALANCE": true,
            "INTEREST_DATE": true,
            "INTEREST": true,
            "INTEREST_LAST_YEAR": true
          }
        },
        "IlhClientServiceInquiryDetailsPolicyCashValuesComponent": {
          "ENABLED": true,
          "CASH_VALUE_ACTIONS": {
            "ENABLED": false,
            "PAY_CASH_SURR": true,
            "PRINT_STATEMENT": true,
            "ISSUE_LOAN": {
              "ENABLED": true,
              "INTEREST_PAID": true,
              "INTEREST_RATE": true,
              "AVAILABLE_VALUE": true
            }
          },
          "CASH_VALUES_FOR": {
            "ENABLED": true,
            "FACE_AMOUNT": true,
            "ATTAIN_AGE": true,
            "ISSUED_DATE": true,
            "ISSUE_AGE": true,
            "MODAL_PREMIUM": true,
            "MODE": true,
            "PREMIUM_DUE_DATE": true,
            "LAST_PAID": true,
            "EXTENDED_TERM": true,
            "PAID_UP": true,
            "NFO": true,
            "DIVIDEND": true
          },
          "NET_CASH_VALUE": {
            "ENABLED": true,
            "BASE_CASH": true,
            "RIDER_CASH": true,
            "DIVIDEND_REFUND": true,
            "OVER_SHORT": true,
            "LESS_POLICY": true,
            "LESS_AUTO": true,
            "PREMIUMS_OWED": true,
            "INTEREST_OWED": true,
            "NET_CASH": true,
            "CURRENT_LOAN": false
          },
          "SURRENDER_VALUE": {
            "ENABLED": true,
            "NET_CASH": true,
            "PURE_ENDOW": false,
            "POLICY_LOAN": true,
            "APL_LOAN": true,
            "REFUND_PREM": true,
            "REFUND_UNEARNED": true,
            "SURR_VALUE": true
          }
        },
        "IlhClientServiceInquiryDetailsPolicyBenefitsComponent": {
          "ENABLED": true,
          "SEGMENT": true,
          "DATE": true,
          "AGE": true,
          "DESC": true,
          "FACE_AMT": true,
          "COMM_PREM": true,
          "NON_COMM_PREM": true,
          "UNITS": true,
          "BENEFIT_DETAILS": {
            "ENABLED": true,
            "UNITS": true,
            "NEXT_CHANGE": true,
            "NEXT_CHANGE_DATE": true,
            "VAL_PER_UNIT": true,
            "NON_FORF": true,
            "VOLUME": true,
            "COMM_SEGMENT": true,
            "DEPENDENT_POINTER": true
          },
          "ANNUAL_PREM_AMT": {
            "ENABLED": true,
            "BASIC_COMM": true,
            "SUB_COMM": true,
            "FLAT_COMM": true,
            "BASIC_NON_COMM": true,
            "SUB_NON_COMM": true,
            "FLAT_NON_COMM": true,
            "TABLE": true,
            "YEARS": true
          }
        },
        "IlhClientServiceInquiryDetailsPolicyPremiumHistoryComponent": {
          "ENABLED": true,
          "PREM_HIST_INFO": {
            "ENABLED": true,
            "PREM_PAID": true,
            "PREM_COUNT": true
          },
          "USER": true,
          "TRANS_DATE": true,
          "DESK_CODE": true,
          "JOURNAL_VOUCHER_NUM": true,
          "CHECK_NUM": true,
          "DESC": true,
          "TRANS_AMT": true,
          "PAID_TO_DATE": true,
          "MONTHS_PAID": true,
          "REFERENCE": true,
          "PREMIUM_HISTORY_ACTIONS": {
            "EXPORT": true
          }
        },
        "IlhClientServiceInquiryDetailsPolicyPremiumIncreaseComponent": {
          "ENABLED": false,
          "FUTURE_TERM_DATE": false,
          "FUTURE_INCREASE_DATE": false,
          "EFFECTIVE_DATE": false,
          "ANNUAL_PREM": false,
          "SEMI_PREM": false,
          "QUARTERLY_PREM": false,
          "MONTHLY_PREM": false,
          "APPLIED_DATE": false
        },
        "IlhClientServiceInquiryDetailsPolicyCommissionInfoComponent": {
          "ENABLED": true,
          "AGENT": true,
          "AGENT_NUM": true,
          "COMM_CODE": true,
          "FIRST": false
        },
        "IlhClientServiceInquiryDetailsPolicyAddressesComponent": {
          "ENABLED": true,
          "CLIENT_NUMBER": true,
          "CLIENT_NAME": true,
          "CONTACT_INFO": {
            "ENABLED": true,
            "EMAIL": true,
            "WORK": true,
            "HOME": true,
            "CELL": true
          },
          "ADDRESS": true
        },
        "IlhClientServiceInquiryDetailsPolicyRelationshipListComponent": {
          "ENABLED": true,
          "VIEW": true
        },
        "IlhClientServiceInquiryDetailsPolicyDividendsComponent": {
          "ENABLED": true,
          "DIVIDEND_ACCUM": {
            "ENABLED": true,
            "BILLED": true,
            "TYPE": true,
            "OPTION": true,
            "INTEREST": true,
            "INTEREST_ACCUM": true,
            "INTEREST_DATE": true,
            "PAID_IN_CASH": true,
            "ENTRY_DATE": true
          },
          "POLICY_LOAN": {
            "ENABLED": true,
            "BALANCE": true,
            "TYPE": true,
            "ENTRY_DATE": true,
            "BILL_CODE": true,
            "INTEREST_DATE": true,
            "RATE": true,
            "CURR_INTEREST": true,
            "INTEREST_YEAR": true
          },
          "PREMIUM_LOAN": {
            "ENABLED": true,
            "BALANCE": true,
            "TYPE": true,
            "ENTRY_DATE": true,
            "BILL_CODE": true,
            "INTEREST_DATE": true,
            "RATE": true,
            "CURR_INTEREST": true,
            "INTEREST_YEAR": true
          }
        },
        "IlhClientServiceInquiryDetailsPolicyCoveragesComponent": {
          "ENABLED": true,
          "EFFECTIVE_DATE": true,
          "PAID_TO_DATE": true,
          "ANNUAL_PREM": true,
          "FACE_AMT": true
        },
        "IlhClientServiceInquiryDetailsPolicyPolicyMessagesComponent": {
          "ENABLED": true,
          "SEGMENT": true,
          "DESK": true,
          "DATE": true,
          "MSG_TEXT": true
        }
      },
      "IlhClientServiceInquiryDetailsClientComponent": {
        "ENABLED": true,
        "CLIENT_INFO": {
          "ENABLED": true,
          "CLIENT_INFO": {
            "ENABLED": true,
            "CLIENT_NUMBER": true,
            "CLIENT_NAME": true,
            "CLIENT_TYPE": true,
            "TITLE": true,
            "SUFFIX": true,
            "MAIL_ADDRESS": true,
            "DELIVERY_METHOD": true,
            "DATE_OF_BIRTH": true,
            "INCEPTION_DATE": true,
            "WEDDING_DATE": true,
            "CONTACT_INFORMATION": {
              "ENABLED": true,
              "EMAIL": true,
              "WORK": true,
              "HOME": true,
              "CELL": true,
              "FAX": true,
              "PAGER": true,
              "WEBSITE": true
            },
            "LANGUAGE": true,
            "GENDER": true,
            "TOBACCO": true,
            "MARITAL_STATUS": true,
            "PRIVACY_RELEASE": true
          },
          "EMPLOYMENT_INFO": {
            "ENABLED": true,
            "CONTACT_INFO": true,
            "PLACE_OF_BUSINESS": true,
            "ADDRESS": true,
            "OCCUPATION": true,
            "TITLE": true,
            "DUTIES": true,
            "EMPLOYMENT_DATE": true,
            "PAY_FREQUENCY": true,
            "OCCUPATION_CHANGE": true
          },
          "MAILING_INFO": {
            "ENABLED": true,
            "ADDRESS": true
          },
          "RESIDENTIAL_INFO": {
            "ENABLED": true,
            "ADDRESS": true,
            "BIRTH_COUNTRY": true,
            "CITIZEN_COUNTRY": true,
            "MAIDEN_NAME": true
          }
        },
        "RELATIONSHIPS": {
          "ENABLED": true
        },
        "POLICIES": {
          "ENABLED": true
        }
      },
      "NOTES": {
        "ENABLED": true,
        "POLICY": {
          "ENABLED": true
        },
        "CLIENT": {
          "ENABLED": true
        }
      },
      "DOCUMENTS": {
        "ENABLED": true,
        "POLICY": {
          "ENABLED": true
        },
        "CLIENT": {
          "ENABLED": true
        }
      },
      "IlhClientServiceInquiryDetailsPolicyRequestLetterComponent": {
        "ENABLED": true
      },
      "IlhClientServiceInquiryDetailsClaimsComponent": {
        "ENABLED": true,
        "IlhClientServiceInquiryDetailsClaimInfoComponent": {
          "ENABLED": true,
          "CLAIM_INFO": {
            "ENABLED": true,
            "HISTORY_DATE": true,
            "STATUS": true
          },
          "ADJUDICATION": {
            "ENABLED": true,
            "FROM": true,
            "THROUGH": true,
            "MESSAGES": true
          },
          "PPO": {
            "ENABLED": true,
            "NETWORKS": true,
            "NETWORK_NAMES": true
          }
        },

        "IlhClientServiceInquiryDetailsClaimsHistoryListComponent": {
          "ENABLED": true,
          "DATE_REC": true,
          "PATIENT": true,
          "ADJ_NUM": true,
          "LAST_ACT": true,
          "VIEW": true,
          "ADD_NOTE": true,

          "IlhClientServiceInquiryDetailsClaimsHistoryDetailsComponent": {
            "ENABLED": true,
            "SQ": true,
            "ACTION": true,
            "PN": true,
            "ADJUDICATION": true,
            "PROVIDER": true,
            "T": true
          }
        }
      },
      "IlhClientServiceInquiryDetailsHouseholdComponent": {
        "ENABLED": false
      }
    }
  },
  "IlhNotesListComponent": {
    "TABLE": {
      "USER": true,
      "TIMESTAMP": true
    }
  }
}
